import React from "react";
import ComicBase from "../ComicBase";

export default function ComicAttackOnTitan() {
  return (
    <ComicBase
      titulo="ANDROIDE 18 x Maestro ROSHI [Zurbaran]"
      portada="https://i.ibb.co/fG92F8XN/androide-18-x-maestro-roshi-1.jpg"
      paginas={[
        "https://i.ibb.co/Rkqr1wkn/androide-18-x-maestro-roshi-2.jpg",
        "https://i.ibb.co/VWf8TX7h/androide-18-x-maestro-roshi-3.jpg",
        "https://i.ibb.co/m5KxfQh9/androide-18-x-maestro-roshi-4.jpg",
        "https://i.ibb.co/S9v88yz/androide-18-x-maestro-roshi-5.jpg",
        "https://i.ibb.co/nqtdKB96/androide-18-x-maestro-roshi-6.jpg",
        "https://i.ibb.co/bMy1hDWG/androide-18-x-maestro-roshi-7.jpg",
        "https://i.ibb.co/bM4m9jKr/androide-18-x-maestro-roshi-8.jpg",
        "https://i.ibb.co/27MVcm6H/androide-18-x-maestro-roshi-9.jpg",
        "https://i.ibb.co/bg8QStJ1/androide-18-x-maestro-roshi-10.jpg",
        "https://i.ibb.co/XffhnFmk/androide-18-x-maestro-roshi-11.jpg",
        "https://i.ibb.co/Mx8dvzVY/androide-18-x-maestro-roshi-12.jpg",
        "https://i.ibb.co/tpCkSyqp/androide-18-x-maestro-roshi-13.jpg",
        "https://i.ibb.co/V0VbfQH1/androide-18-x-maestro-roshi-14.jpg",
        "https://i.ibb.co/G3t0R7FN/androide-18-x-maestro-roshi-15.jpg",
        "https://i.ibb.co/8gnCJrpN/androide-18-x-maestro-roshi-16.jpg",
        "https://i.ibb.co/chtGrVGY/androide-18-x-maestro-roshi-17.jpg",
        "https://i.ibb.co/6ckf8k0q/androide-18-x-maestro-roshi-18.jpg",

      ]}
       sugeridos={[
      
      ]}


      info={{
        grupo: "",
        tipo: "Zurbaran",
        idioma: "Español",
        serie: "Dragon Ball",
        personajes: ["Nr18", "Roshi"],
etiquetas: ["Incompletos", "Dibujos", "Inteligencia Artificial", "DBZ", "Dragon Ball"],
        artistas: "Zurbaran",
      }}
    />
  );
}

/* 🔥 infoManga exportado para detección automática */
export const infoManga = {
  titulo: "ANDROIDE 18 x Maestro ROSHI [Zurbaran]",
  portada: "https://i.ibb.co/fG92F8XN/androide-18-x-maestro-roshi-1.jpg",
  reverso: "https://i.ibb.co/Rkqr1wkn/androide-18-x-maestro-roshi-2.jpg",
     enlace: "/comic/ANDROIDE-18-x-Maestro-ROSHI", // 👈 Añadí esta línea
             fecha:"2026-05-9", // 👈 MOVER AQUÍ


  info: {
    grupo: "",
        tipo: "Zurbaran",
        idioma: "Español",
        serie: "Dragon Ball",
        personajes: ["Nr18", "Roshi"],
etiquetas: ["Incompletos", "Dibujos", "Inteligencia Artificial", "DBZ", "Dragon Ball"],
        artistas: "Zurbaran",
  },
};
